import { useQuery } from "@tanstack/react-query";

import { type RouterOutputs, useTRPC } from "src/api/trpc";

export type SolutionListItem = RouterOutputs["v1"]["solutions"]["list"][number];

/** The organization's solutions, most recently updated first (shared by the nav count, Launchpad and My Solutions). */
export const useSolutions = () => {
	const trpc = useTRPC();
	return useQuery(trpc.v1.solutions.list.queryOptions());
};
